import { cn } from '@/lib/cn';

interface ButtonGroupProps {
  children: React.ReactNode;
  className?: string;
}

export function ButtonGroup({ children, className }: ButtonGroupProps) {
  return (
    <div
      className={cn(
        'inline-flex rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] p-0.5',
        className
      )}
    >
      {children}
    </div>
  );
}

interface ToggleButtonProps {
  children: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
  'aria-label'?: string;
}

export function ToggleButton({
  children,
  isActive = false,
  onClick,
  className,
  'aria-label': ariaLabel,
}: ToggleButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(
        'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
        'flex items-center gap-1.5',
        isActive
          ? 'bg-accent-primary text-white'
          : 'text-[var(--color-text)] hover:bg-[var(--color-border)]',
        className
      )}
    >
      {children}
    </button>
  );
}
